
export class SalesOrderBusinesPlan {
 UserName:string = "";
 TargetFor: string = "";
 Year:string = "";
 Month:number;
 Units:number;
 Amount:number;
 Fk_UserId_Target:string;
}